module.exports = __webpack_public_path__ + "img/icon-add.287dec8f.svg";